import { ChangeDetectionStrategy, Component } from '@angular/core'

import { CmpVideo } from 'app/core/cms/generated/api-types'
import { explicitComputed } from 'app/utils/signal-utils'

import { CmsBlock } from '../../cms-block'
import { LazyVimeoComponent } from './lazy-vimeo/lazy-vimeo.component'
import { LazyYoutubeComponent } from './lazy-youtube/lazy-youtube.component'

@Component({
  selector: 'pai-cmp-video',
  templateUrl: './cmp-video.component.html',
  styleUrls: ['./cmp-video.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [LazyYoutubeComponent, LazyVimeoComponent],
  providers: [{ provide: CmsBlock, useExisting: CmpVideoComponent }],
})
export class CmpVideoComponent extends CmsBlock<CmpVideo> {
  readonly __typename = 'CmpVideo'

  readonly ratio = explicitComputed(this.data, ({ width, height }): string => {
    const [w, h] = [width ?? 16, height ?? 9]
    return `${w} / ${h}`
  })
}
